<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolTt2_1d01"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolTt2_1d01 from '@/device-products/ResolTt2_1d01.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: ResolTt2_1d01, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
